import { FormGroup, FormLabel, FormSelect } from 'react-bootstrap';
import { useTheme } from 'styled-components';

interface SelectProps {
  value?: string | number;
  label: string;
  disabled?: boolean;
  name: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  options: { value: any; label: string }[];
  style?: React.CSSProperties;
  required?: boolean;
  borderRadius?: string;
}

export default function Select({
  value,
  label,
  disabled,
  name,
  onChange,
  onClick,
  options,
  style,
  required,
  borderRadius = '10px',
}: SelectProps) {
  const theme = useTheme();

  return (
    <FormGroup>
      <FormLabel style={{ color: theme.colors.textoAzul }}>
        {required ? (
          <>
            <span
              style={{
                color: theme.colors.botaoConfirmar,
                fontWeight: 'bold',
              }}
            >
              {required ? (
                <>
                  <span
                    style={{
                      color: theme.colors.botaoConfirmar,
                      fontWeight: 'bold',
                    }}
                  >
                    {label}
                  </span>
                  <span
                    style={{
                      color: theme.colors.vermelho,
                      fontWeight: 'bold',
                    }}
                  >
                    *
                  </span>
                </>
              ) : (
                label
              )}
            </span>
          </>
        ) : (
          label
        )}
      </FormLabel>
      <div
        onClick={(e) => {
          if (onClick) {
            e.stopPropagation(); // Evita propagação para o <FormSelect>
            onClick(e); // Chama a função passada como `onClick`
          }
        }}
        style={{
          position: 'relative',
          cursor: 'pointer',
          borderRadius: borderRadius,
          ...style,
        }}
      >
        <FormSelect
          value={value}
          disabled={disabled}
          onChange={onChange}
          name={name}
          required={required}
          style={{
            borderRadius: '10px',
            border: `1px solid ${theme.colors.bordaInput}`,
            pointerEvents: disabled ? 'none' : 'auto',
            ...style,
          }}
        >
          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              hidden={option.value == '0' ? true : false}
            >
              {option.label}
            </option>
          ))}
        </FormSelect>
      </div>
    </FormGroup>
  );
}
